<template>
    <div>
        <!--<breadcrumb :routerList="[{to:'/yuce/sellOn_list',title:'市场预测'},{title:'预测报表'}]"/>-->
      <Breadtabsheader/>
        <div style="margin:20px">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="预测月份">
							    <el-date-picker
							            :clearable="true"
							            v-model="formInline.formation"
							            type="month"
										style="width: 100%;"
							            value-format="yyyy-MM"
							            placeholder="--月份--">
							    </el-date-picker>
							</el-form-item>
							<el-form-item v-if="showArea" label="销售区域">
							    <brselect placeholder="请选择"
							              category="YLRegion"
							              :v="formInline.area"
							              clearable
										  style="width: 100%;"
							              v-model="formInline.area">
							    </brselect>
							</el-form-item>
							<el-form-item label="产品大类">
							    <el-select v-model="formInline.productType" placeholder="请选择" clearable>
							        <el-option v-for="(item,index) in opt"
							                   :key="item"
							                   :label="item"
							                   :value="item">
							        </el-option>
							    </el-select>
							</el-form-item>
							<el-form-item label="销售渠道">
							    <brselect placeholder="请选择"
							              category="sales_region"
							              :v="formInline.trench"
							              clearable
										  style="width: 100%;"
							              v-model="formInline.trench">
							    </brselect>
							</el-form-item>
						</div>
						<div class="h-formBtnOut h-columnCenter">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						    <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
						</div>
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            @selection-change="handleSelectionChange"
                            :data="tableData"
                            stripe
							border
							max-height="450"
                            style="width: 100%">
                        <el-table-column
                                type="selection"
                                width="45">
                        </el-table-column>
                        <el-table-column
                                type="index"
								fixed
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="area"
                                :show-overflow-tooltip="true"
								width="60"
                                label="区域">
                            <template slot-scope="scope">
                                <dictname category="YLRegion"  :v="scope.row.area"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="customer"
                                :show-overflow-tooltip="true"
								min-width="180"
                                label="客户名称">
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.customer}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="trench"
                                :show-overflow-tooltip="true"
								width="80"
                                label="渠道">
                            <template slot-scope="scope">
                                <dictname category="sales_region"  :v="scope.row.trench"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="targetUser"
								width="180"
                                :show-overflow-tooltip="true"
                                label="目标用户">
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.targetUser}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="productType"
								width="110"
                                :show-overflow-tooltip="true"
                                label="产品大类">
                        </el-table-column>
                        <el-table-column
                                prop="productModel"
                                :show-overflow-tooltip="true"
                                label="产品型号"
								width="180">
									<template slot-scope="scope">
										<div style="text-align: left;">
											{{scope.row.productModel}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="num"
                                :show-overflow-tooltip="true"
								width="60"
                                label="数量">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.num}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="sales"
                                :show-overflow-tooltip="true"
								width="90"
                                label="实际销量">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.sales}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="ratio"
								width="100"
                                :show-overflow-tooltip="true"
                                label="比例">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.ratio}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="price"
								width="90"
                                :show-overflow-tooltip="true"
                                label="单价(元)">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.price}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="totalSales"
								width="110"
                                :show-overflow-tooltip="true"
                                label="总销额(元)">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.totalSales}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="income"
								width="90"
                                :show-overflow-tooltip="true"
                                label="收入(元)">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.income}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="formationTime"
                                :show-overflow-tooltip="true"
								width="120"
                                label="预计成单日期">
                        </el-table-column>
                        <el-table-column
                                prop="week"
                                :show-overflow-tooltip="true"
								width="90"
                                label="第几周">
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                :show-overflow-tooltip="true"
								width="160"
                                label="创建时间">
                        </el-table-column>
                        <el-table-column
                                prop="orderType"
                                :show-overflow-tooltip="true"
                                label="订单类型"
								width="90"
                                class-name="h-tableInputTd">
                            <template slot-scope="scope">
                                <dictname category="yuce_type"  :v="scope.row.orderType"/>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                        </div>
                        <div class="h-pagination2 h-pageCenter">
                            <pagination :page="formInline" @query="handleFilter" />
                        </div>
                    </div>
                </div>
            </div>
<!--            <div class="h-txtCenter h-mrt60">-->
<!--                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="renovate">返回</el-button>-->
<!--            </div>-->
        </div>
    </div>
</template>
<script>

    import big from 'big.js'
    import ss from '../../../api/SystemService';
    import updownfile from '../../../utils/updownfile'

    export default {
        data() {
            return {
                formInline: {
                    formation : '',
                    area : '',
                    productType : '',
                    trench : '',
                    idlist: [],
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                opt:[],
                tableData: [],
                userRole: [],
                multipleSelection: [],
                showArea: true,
                a: ''
            }
        },
        mounted() {

        },
        created() {
            this.query();
            this.showLevName();
        },
        methods: {
            // 重置按钮
            resetData() {
                this.formInline.formation = '';
                this.formInline.area = '';
                this.formInline.productType = '';
                this.formInline.trench = '';
                this.formInline.pageSize = 10;
                this.formInline.pageNo = 1;
                this.query();
            },
            getyyyyMMdd() {
                const now = new Date()
                return [now.getFullYear(),
                    now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1,].join('-');
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //明细导出
            exportExcel() {
                // var idlist=[];
                // this.multipleSelection.forEach(element => {
                //     idlist.push(element.id);
                // });
                this.formInline.idlist = [];
                if (this.multipleSelection.length > 0) {
                    this.multipleSelection.forEach(element => {
                        this.formInline.idlist.push(element.id);
                    });
                }
                updownfile.down("/api/swyl/v1/demo/bscForecastplanDetailed/downloadReportExcel",this.formInline,"post",'data');
            },
            query() {
                this.userRole = this._user.roles;
                this.userRole.forEach((item, index) => {
                    if (item.id == "swyl_quyujl") {
                        this.a = 2;
                    }
                })
                if (this.a == 2) {
                    this.showArea = false;
                }
                ss.pingshen.selectReport(this.formInline).then(rd => {
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            showLevName() {
                ss.pingshen.showLName().then(rd => {
                    this.opt = rd;
                })
            },
            handleFilter(){
                console.log(this.formInline);
                ss.pingshen.selectReport(this.formInline).then(rd => {
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            renovate() {
                this.$router.push({path: "/yuce/sellOn_list"});
            },
        }
    }
</script>
